import { forwardRef, HTMLAttributes, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

interface PortalDropdownMenuProps extends HTMLAttributes<HTMLDivElement> {
	children: React.ReactNode;
	style?: React.CSSProperties;
	className?: string;
	'aria-labelledby'?: string;
	show?: boolean;
}

const PortalDropdownMenu = forwardRef<HTMLDivElement, PortalDropdownMenuProps>((props, ref) => {
	const { children, style, className, 'aria-labelledby': labeledBy, show, ...rest } = props;
	const [portalContainer, setPortalContainer] = useState<HTMLElement | null>(null);

	useEffect(() => {
		// Ensure we have a valid container
		if (!portalContainer) {
			const container = document.body;
			setPortalContainer(container);
		}

		// Cleanup function
		return () => {
			// Any cleanup needed when component unmounts
		};
	}, [portalContainer]);

	if (!portalContainer) {
		return null;
	}

	try {
		return ReactDOM.createPortal(
			<div ref={ref} style={{ ...style, zIndex: 1050 }} className={className} aria-labelledby={labeledBy} {...rest}>
				{children}
			</div>,
			portalContainer
		);
	} catch (error) {
		console.error('Error creating portal:', error);
		return null;
	}
});

PortalDropdownMenu.displayName = 'PortalDropdownMenu';

export default PortalDropdownMenu;
